import React, { useEffect, useState } from 'react';
import Phone from '../Phone/Phone';
import { Prompt } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { updateSettings } from '../../helper/updateSettings';

const Wishlist = () => {
	const { merchantId, merchantOptions, currentMerchant } = useSelector(
		state => ({
			merchantId: state.auth.user.merchantId,
			merchantOptions: state.merchants.merchants[0].options,
			currentMerchant: state.merchants.merchants[0],
		}),
	);
	const defaultSettings = {
		activeColor: '#000',
		backgroundActiveColor: '#ffffff',
		borderInactiveColor: '#ffffff',
		inactiveColor: '#ffffff',
		backgroundColor: '#C15EFE',
		outlineInActiveColor: '#ffffff',
	};
	const [settings, setSettings] = useState(defaultSettings);
	const [loading, setLoading] = useState(false);
	const [isBlocking, setIsBlocking] = useState(false);
	const [alert, setAlert] = useState({
		display: false,
		message: '',
		type: '',
	});

	useEffect(() => {
		setSettings(merchantOptions);
	}, [merchantOptions]);

	const saveSettings = async () => {
		try {
			setAlert({ display: false });
			setLoading(true)
			currentMerchant.options = { ...currentMerchant.options, ...settings }
			await updateSettings(currentMerchant, merchantId);
			setLoading(false)
			setAlert({ display: true, message: 'Data saved successfully', type: 'primary' });
			setIsBlocking(false);

		} catch (error) {
			console.error(error);
		}
	};

	const handleChange = e => {
		if (e.target.type === 'checkbox') {
			setSettings({ ...settings, [e.target.name]: !settings[e.target.name] });
		} else {
			setSettings({ ...settings, [e.target.name]: e.target.value });
		}
		setIsBlocking(true);
	};

	return (
		<>
			<div className='page-wrapper'>
				<Prompt
					when={isBlocking}
					// message={location => `Are you sure you want to go to ${location.pathname}`}
					message={location => `Save your modification?`}
				/>
				<div className='col-xxl-5'>
					<div className='card-visibility'>
						<div className='card-vi-header'>
							<span className='fw-bold text-dark'>Wishlist</span>
						</div>
						<div className='card-body-visibility'>
							<div className='bah-accordion'>
								<div className='bah-accordion_header'>
									{alert.display && (
										<div
											profile='alert'
											className={`mb-10 alert alert-custom alert-light-${alert.type} alert-dismissible`}
										>
											<div className='alert-text font-weight-bold'>{alert.message}</div>
										</div>
									)}
									<span className='bah-accordion__element__header fw-bold label-vi'>
										Active Colors
									</span>
									<div className='color-select'>
										<label className='input-label'>Heart</label>
										<div className='color-input'>
											<input
												type='color'
												className='color-box field-radio'
												name='activeColor'
												value={settings.activeColor || defaultSettings.activeColor}
												onChange={handleChange}
											/>
										</div>
									</div>
									<div className='color-select'>
										<label className='input-label'>Background</label>
										<div className='color-input'>
											<input
												type='color'
												className='color-box field-radio'
												name='backgroundActiveColor'
												value={settings.backgroundActiveColor || defaultSettings.backgroundActiveColor}
												onChange={handleChange}
											/>
										</div>
									</div>
									<div className='color-select'>
										<label className='input-label'>Outline</label>
										<div className='color-input'>
											<input
												type='color'
												className='color-box field-radio'
												name='borderInactiveColor'
												value={settings.borderInactiveColor || defaultSettings.borderInactiveColor}
												onChange={handleChange}
											/>
										</div>
									</div>
								</div>
								<div className='bah-accordion_header'>
									<span className='bah-accordion__element__header fw-bold label-vi'>
										Inactive Colors
									</span>
									<div className='color-select'>
										<label className='input-label'>Heart</label>
										<div className='color-input'>
											<input
												type='color'
												className='color-box field-radio'
												name='inactiveColor'
												value={settings.inactiveColor || defaultSettings.inactiveColor}
												onChange={handleChange}
											/>
										</div>
									</div>
									<div className='color-select'>
										<label className='input-label'>Background</label>
										<div className='color-input'>
											<input
												type='color'
												className='color-box field-radio'
												name='backgroundColor'
												value={settings.backgroundColor || defaultSettings.backgroundColor}
												onChange={handleChange}
											/>
										</div>
									</div>
									<div className='color-select'>
										<label className='input-label'>Outline</label>
										<div className='color-input'>
											<input
												type='color'
												className='color-box field-radio'
												name='outlineInActiveColor'
												value={settings.outlineInActiveColor || defaultSettings.outlineInActiveColor}
												onChange={handleChange}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='my-4 save-btn-wrapper' onClick={saveSettings}>
						<button className='btn btn-dark'>
							{loading ?
								<>
									<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
								</>
								:
								<>
									Publish
								</>
							}
						</button>
					</div>
				</div>
				<Phone />
			</div>
		</>
	);
};

export default Wishlist;
